import React from 'react';

import {asClassComponent} from '/util/hoc.util';

import {
  setDarkText,
  setLightText,
  setWhiteBackground,
} from './withStatusBar.util';

export default (Component: any) =>
  asClassComponent((props: any) => (
    <Component
      {...props}
      statusBarSetDarkText={setDarkText}
      statusBarSetLightText={setLightText}
      statusBarSetWhiteBackground={setWhiteBackground}
    />
  ));
